export default __webpack_public_path__ + "static/media/shoppage-bestsale.d6c02dab.svg";